"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressivePrize = void 0;
class ProgressivePrize {
    constructor(data) {
        this.id = data.id;
        this.content = data.content;
        this.summary = data.summary;
        this.winType = data.winType;
        this.totalWinners = data.totalWinners;
        this.type = data.type;
        this.value = data.value;
        this.drawId = data.drawId;
        this.ceiling = data.ceiling;
        this.multipler = data.multipler;
        this.constant = data.constant;
    }
}
exports.ProgressivePrize = ProgressivePrize;
ProgressivePrize.JsonToEntities = (data) => data.map(ProgressivePrize.JsonToEntity);
ProgressivePrize.JsonToEntity = (data) => new ProgressivePrize(data);
//# sourceMappingURL=ProgressivePrize.js.map